import { NavigationProvider } from './navigation';
import React, { useEffect, useState } from 'react';
import { RootSiblingParent } from 'react-native-root-siblings';
import { useStore } from 'react-redux';
//import { PersistGate } from 'redux-persist/integration/react';
import { wrapper } from 'reducers/store';
import { Platform } from 'react-native';
import { toastConfig } from 'components/utility/Notifications';
import { activateSideEffects } from 'provider/services/services';
import { NextThemeProvider } from '@tamagui/next-theme';
import { TamaProvider } from 'app/provider/tamaprovider';
import { useSelector } from 'react-redux';
import { PersistGate as PersistGateClient } from 'redux-persist/integration/react';
import withSettingsSync from 'app/provider/withSettingsSync';
import withAuthModal from 'app/provider/withAuthModal';
import { Stack, SizableText } from 'tamagui';
import { SettingsProvider } from 'contexts/SettingsContext';
import { AudioProvider } from 'contexts/AudioContext';
import loadable from '@loadable/component';
const Toast = loadable(() => import('react-native-toast-message'));
function PersistGateServer(props) {
  return props.children;
}
function ThemeProvider({
  children
}) {
  // Replace settings with uisettings slice
  const uisettings = useSelector(state => state.uisettings);
  const dark_mode = uisettings.darkMode;
  const theme = dark_mode ? 'dark' : 'light';
  return /*#__PURE__*/React.createElement(NextThemeProvider, {
    forcedTheme: theme
  }, /*#__PURE__*/React.createElement(TamaProvider, {
    disableInjectCSS: true,
    disableRootThemeClass: true,
    defaultTheme: theme
  }, children));
}
console.disableYellowBox = true;
function NoMatch({
  location
}) {
  return /*#__PURE__*/React.createElement(SizableText, null, "No match for ", location.pathname);
}
activateSideEffects();
if (Platform.OS !== 'web') {
  oneSignal();
}
const inset = {
  frame: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  insets: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};
const ProviderChild = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(NavigationProvider, null, /*#__PURE__*/React.createElement(RootSiblingParent, null, /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(Persist, null, /*#__PURE__*/React.createElement(SettingsProvider, null, /*#__PURE__*/React.createElement(AudioProvider, null, children, " "))), /*#__PURE__*/React.createElement(Toast, {
    config: toastConfig
  }))));
};
const ProviderChildWithAuthModal = withAuthModal(ProviderChild);
const Persist = ({
  children
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    return () => {
      setIsClient(false);
    };
  }, []);
  const store = useStore(state => state);
  let PersistGate = PersistGateServer;
  if (isClient) {
    PersistGate = PersistGateClient;
  }
  return /*#__PURE__*/React.createElement(PersistGate, {
    loading: null,
    persistor: store.__persistor
  }, children);
};
export const Provider = wrapper.withRedux(withSettingsSync(ProviderChildWithAuthModal));